import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';

import { messages } from '../messages';

const QuantityCell = ({ row, isReadOnly }) => {
  const { isHeader } = row?.original || {};
  const { quantity = 0 } = row?.values || {};

  if (isHeader) {
    return null;
  }

  if (isReadOnly) {
    return <Text textType={TextType.Paragraph} value={quantity} />;
  }

  return <Text textType={TextType.Paragraph} value={quantity} />;
};

export const createTotalQuantityColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'quantity',
  Header: <FormattedMessage {...messages.totalQuantity} />,
  Cell: QuantityCell,
  width: 1,
});
